import React from "react";
import { Rate } from "antd";
import "./style.css";

const InputRating = (props) => {
  const {
    id,
    name,
    label,
    value,
    disabled,
    allowHalf,
    className,
    onChange,
    formatId,
    fieldClass,
  } = props;

  return (
    <div
      className={`rating-star-input ${fieldClass || ""}`}
      id={formatId && formatId(name || label)}
      key={id}
    >
      <div className="font-16-regular-500-lh-32">{label}</div>
      <Rate
        value={value}
        defaultValue={value}
        disabled={disabled}
        allowHalf={allowHalf}
        onChange={onChange}
        className={className}
      />
    </div>
  );
};

export default InputRating;
